import {
  Exceptions,
  WAPP_ACTIVITY_CREATE_ENTITY,
  WAPP_ACTIVITY_DELETE_ENTITY,
  WAPP_ACTIVITY_EDIT_ENTITY,
  WAPP_ACTIVITY_POST,
  WAPP_ACTIVITY_SEARCH,
  WappActivityCreateEntityAPI,
  WappActivityDeleteEntityAPI,
  WappActivityEditEntityAPI,
  WappActivityPostAPI,
  WappActivitySearchAPI,
} from '@weblite-wapps/protocol'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'
import {
  createEntity,
  decodeContentUri,
  deleteEntity,
  editEntity,
  postActivity,
  searchEntities,
} from '$logic/wapp-activity'
import { getWapp } from '$logic/wapps/service'

wappSubscription.subscribe<WappActivitySearchAPI>(
  WAPP_ACTIVITY_SEARCH,
  async query => {
    try {
      return searchEntities(query)
    } catch (_) {
      return { statusCode: Exceptions.NOT_ALLOWED }
    }
  },
)

wappSubscription.subscribe<WappActivityPostAPI>(
  WAPP_ACTIVITY_POST,
  async activity => {
    try {
      await postActivity(activity)
      return { status: 'ok' }
    } catch (_) {
      return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
    }
  },
)

wappSubscription.subscribe<WappActivityCreateEntityAPI>(
  WAPP_ACTIVITY_CREATE_ENTITY,
  async (activity, meta) => {
    try {
      return createEntity(activity, meta.wappId)
    } catch (_) {
      return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
    }
  },
)

wappSubscription.subscribe<WappActivityEditEntityAPI>(
  WAPP_ACTIVITY_EDIT_ENTITY,
  async (activity, meta) => {
    try {
      await editEntity(activity, meta.wappId)
      return { status: 'ok' }
    } catch (_) {
      return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
    }
  },
)

wappSubscription.subscribe<WappActivityDeleteEntityAPI>(
  WAPP_ACTIVITY_DELETE_ENTITY,
  async ({ contentUri }, { wappId }) => {
    try {
      const { instanceId, tenant } = decodeContentUri(contentUri)

      const wapp = await getWapp(wappId)
      if (tenant !== wapp.groupName) {
        console.error(
          `${wapp.groupName} has no access to change ${tenant}'s entity`,
        )
        return { errorCode: Exceptions.NOT_ALLOWED }
      }

      await deleteEntity(instanceId, tenant)
      return { status: 'ok' }
    } catch (_) {
      return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
    }
  },
)
